import { render, staticRenderFns } from "./NoDataInterfaceEditable.vue?vue&type=template&id=c06398ca&scoped=true&"
import script from "./NoDataInterfaceEditable.vue?vue&type=script&lang=js&"
export * from "./NoDataInterfaceEditable.vue?vue&type=script&lang=js&"
import style0 from "./NoDataInterfaceEditable.vue?vue&type=style&index=0&id=c06398ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06398ca",
  null
  
)

export default component.exports